import { DateTimeType } from "../../../types";
import { DateFromISO } from "sb-js-extends";
import { getCurrentTime } from "sb-resp-utils";
import { dateOptions, yearOptions, time12Options, time24Options } from "../../../constants";
DateFromISO();
const dateOptionsMap = {
    format12Hour: Object.assign(Object.assign(Object.assign({}, dateOptions), yearOptions), time12Options),
    format24Hour: Object.assign(Object.assign(Object.assign({}, dateOptions), yearOptions), time24Options)
};
const timeOptionsMap = {
    format12Hour: Object.assign({}, time12Options),
    format24Hour: Object.assign({}, time24Options)
};
export const buildDateTimeFormatter = (type, hourOptions, getDateTimeFormatter) => {
    const options = type === DateTimeType.time
        ? timeOptionsMap[hourOptions]
        : dateOptionsMap[hourOptions];
    return formatIsoDateTime.bind(undefined, getDateTimeFormatter(options));
};
function formatIsoDateTime(formatter, isoDateTime, timeZone) {
    const currentDateTime = Date.fromISO(isoDateTime);
    if (!currentDateTime) {
        return "";
    }
    const dateTime = getCurrentTime(currentDateTime, timeZone);
    return formatter.format(dateTime);
}
//# sourceMappingURL=buildDateTimeFormatter.js.map